import React from 'react';
import { Chip } from '@mui/material';
import H4 from '../../shims/commonUiH4';
import { statusColorMap } from '../../constants/statusColors';

function formatDate(iso) {
  if (!iso) return '';
  return new Intl.DateTimeFormat(navigator.language, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso));
}

export default function TicketHeader({ ticketId, subject, status, createdAt, updatedAt }) {
  return (
    <div className="mb-3">
      <H4 attrH4={{ className: 'title-color' }}>{subject}</H4>
      <div className="d-flex flex-wrap gap-2 align-items-center">
        <Chip label={ticketId} size="small" variant="outlined" />
        <Chip label={status} color={statusColorMap[status] || 'default'} size="small" />
        <span className="text-muted small">Created: {formatDate(createdAt)}</span>
        {updatedAt && <span className="text-muted small">Updated: {formatDate(updatedAt)}</span>}
      </div>
    </div>
  );
}
